import React, { Component } from "react";

import { Metric, selectFormat } from "./../Utils/Utils.js";
import Heading from "../Elements/Heading";

class FreeTrialConversion extends Component {
  render() {
    const { data, url } = this.props;

    const bar2_width = (data.converted_to_paid * 100) / data.free_trial_ended;
    const bar1_style = { width: "100%" };
    const bar2_style = { width: bar2_width + "%" };

    const isLeeEnterprises =
      url.indexOf("lee-enterprises/billing-free-trial-conversions-live") > 0;

    return (
      <div className="row">
        <div className="col-12">
          <div className="text-center">
            <Heading size={6} className={"mb-0 text-gray"}>
              {data.name}
            </Heading>
          </div>

          <div className="bar-chart">
            <div className="bar-chart__container pl-3 pr-3">
              <div
                className="bar-chart__bar bar-chart__bar--pink"
                style={bar1_style}
              ></div>
              <div className="bar-chart__data">
                <div className="bar-chart__label">
                  {isLeeEnterprises
                    ? "First Offer Subscriptions"
                    : "Free Trial Ends"}
                </div>
                <div className="bar-chart__value">
                  {selectFormat("number", data.free_trial_ended)}
                </div>
              </div>
            </div>

            <div className="bar-chart__container pl-3 pr-3">
              <div
                className="bar-chart__bar bar-chart__bar--green"
                style={bar2_style}
              ></div>
              <div className="bar-chart__data">
                <div className="bar-chart__label">
                  {isLeeEnterprises
                    ? "Converted to Next Offer"
                    : "Converted to Paid"}
                </div>
                <div className="bar-chart__value">
                  {selectFormat("number", data.converted_to_paid)}
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-4">
              <Heading size={6} className={"mb-0"}>
                Conversion Rate
              </Heading>
              <Metric
                {...data.conversion_rate}
                size={"sm"}
                format={"%"}
                type="percentage"
              />
            </div>

            <div className="col-4">
              <Heading size={6} className={"mb-0"}>
                Cancelled
              </Heading>
              <Metric {...data.cancelled} size={"sm"} format={"0"} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FreeTrialConversion;
